module.exports = __webpack_public_path__ + "img/mile2-m@2.536e5fdf.jpg";